import { render } from "./ChankangPack.vue?vue&type=template&id=1b984d24&ts=true"
import script from "./ChankangPack.vue?vue&type=script&lang=ts"
export * from "./ChankangPack.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__